module.exports = __webpack_public_path__ + "static/media/nursing_management3.c2913522.png";